import * as warehouseDenialCauses from './warehouseDenialCauses';
import * as StoragePending from './storagePending';
import * as ManualsOrders from './manualsOrders';
import * as ShiftsActions from './shifts';
import * as Locations from './locations';
import * as Dashboard from './dashboard';
import * as Scanning from './scanning';
import * as Zones from './zones';

const reducers = {
  ...warehouseDenialCauses,
  ...ShiftsActions,
  ...Zones,
  ...Locations,
  ...Scanning,
  ...StoragePending,
  ...ManualsOrders,
  ...Dashboard,
};

export default reducers;
